import React, { Component } from "react";
import video from "../img/video-low3.mp4";
import logo from "../img/AAY_Logo_Outline.svg";
// import FontAwesomeIcon from '@fortawesome/react-fontawesome'
// import faAngleDoubleDown from '@fortawesome/fontawesome-free-solid/faAngleDoubleDown'
import Links from "./Links";
import { Link } from "react-router-dom";

import "../css/Landing.css";
import landingBottom from "../img/Landing/Landing-bottom-starfish.png";

class Landing extends Component {
  componentDidMount() {
    var TxtType = function (el, toRotate, period) {
      this.toRotate = toRotate;
      this.el = el;
      this.loopNum = 0;
      this.period = parseInt(period, 10) || 2000;
      this.txt = "";
      this.tick();
      this.isDeleting = false;
    };

    TxtType.prototype.tick = function () {
      var i = this.loopNum % this.toRotate.length;
      var fullTxt = this.toRotate[i];

      if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
      } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
      }

      this.el.innerHTML = '<span class="wrap">' + this.txt + "</span>";

      var that = this;
      var delta = 200 - Math.random() * 100;

      if (this.isDeleting) {
        delta /= 2;
      }

      if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
      } else if (this.isDeleting && this.txt === "") {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
      }

      setTimeout(function () {
        that.tick();
      }, delta);
    };

    var elements = document.getElementsByClassName("typewrite");
    for (var i = 0; i < elements.length; i++) {
      var toRotate = elements[i].getAttribute("data-type");
      var period = elements[i].getAttribute("data-period");
      if (toRotate) {
        new TxtType(elements[i], JSON.parse(toRotate), period);
      }
    }

    // INJECT CSS
    var css = document.createElement("style");
    css.type = "text/css";
    css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #fff}";
    document.body.appendChild(css);
  }

  render() {
    return (
      <section className='landing'>
        <video autoPlay muted loop>
          <source src={video} type='video/mp4' />
        </video>
        <div className='dim'></div>
        <Links />
        <div className='banner-contents'>
          <img src={logo} id='logo' alt='logo' />
          <h2 id='title'>All About You</h2>
          <h4 id='tag'>Lingerie & Wig Boutique</h4>
          <br />
          <Link to={"/giftcards"} className='gift-card-btn'>
            Buy Gift Cards
          </Link>
          {/*<div class='typewrite' data-type='["Grand Opening April 6th!", "Join us for prizes and savings!"]' data-period='1000' />*/}
        </div>
        <div
          id='landing-bottom'
          style={{ backgroundImage: `url(${landingBottom})` }}
        ></div>
      </section>
    );
  }
}
// <div className="arrow-down"><FontAwesomeIcon icon={faAngleDoubleDown} size="2x" id="down-arrow"/></div>
// <p id="logo-credit">Logo: Jon Duggan</p>
// <h3 className="typewrite" id="opening-soon" data-period="5000" data-type='["Open Now! Come in and see us!"]'>
// <span className="wrap"></span>
// </h3>
export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing.jsx